import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'workforce',
    label: 'Workforce',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
